// @flow

import { CARD_LOGS_UPDATE_FAILURE, CARD_LOGS_UPDATE_SUCCESS, CARD_LOGS_UPDATE_REQUEST } from './constant';

const initialState = {
  error: '',
  id: '',
  action: '',
  lotNumber: 0,
};

export default function reducer(state: CardStoreType = initialState, action: ActionType): CardStoreType {
  switch (action.type) {
    case CARD_LOGS_UPDATE_REQUEST: {
      const {
        payload: { id, guardAction, lotNumber },
      } = action;
      return {
        ...state,
        id,
        action: guardAction,
        lotNumber,
      };
    }
    case CARD_LOGS_UPDATE_SUCCESS: {
      return {
        ...initialState,
      };
    }
    case CARD_LOGS_UPDATE_FAILURE: {
      const {
        payload: { message },
      } = action;
      return {
        ...initialState,
        error: message,
      };
    }
    default:
      return state;
  }
}
